import { defineMessages } from '@/i18n';

export const listingDetailsMessages = defineMessages({
  detailsBtnLabel: 'platform.app.activations.listings.details.listingsDetailBtn',
  qrCodeButtonLabel: 'platform.app.activations.listings.details.listingsQrBtn',
  priceVisibilityTitle: 'platform.app.activations.listings.details.title',
  priceVisibilityDescription: 'platform.app.activations.listings.details.description',
  priceOptionVisibleLabel: 'platform.app.activations.listings.details.priceOptions.visible',
  priceOptionVisibleDescription: 'platform.app.activations.listings.details.priceOptions.visible.description',
  priceInputLabel: 'platform.app.activations.listings.details.priceInputLabel',
  listedLabel: 'platform.app.activations.listings.details.listedLabel',
  listedLabelDescription: 'platform.app.activations.listings.details.listedLabelDescription',
  unlistedLabel: 'platform.app.activations.listings.details.unlistedLabel',
  unlistedLabelDescription: 'platform.app.activations.listings.details.unlistedLabelDescription',
  showOperators: 'platform.app.activations.listings.details.unlistedLabelFallbackShowOperators',
  fromPriceInputLabel: 'platform.app.activations.listings.details.fromPriceInputLabel',
  toPriceInputLabel: 'platform.app.activations.listings.details.toPriceInputLabel',
  priceOptionOnRequestLabel: 'platform.app.activations.listings.details.priceOptions.on_request',
  priceOptionOnRequestDescription: 'platform.app.activations.listings.details.priceOptions.on_request.description',
  priceOptionRangeLabel: 'platform.app.activations.listings.details.priceOptions.range',
  priceOptionRangeDescription: 'platform.app.activations.listings.details.priceOptions.range.description',
  listingUpdated: 'platform.app.activations.listings.details.updatedNotificationTitle',
  errorCurrencyRequired: 'platform.app.activations.listings.details.errorCurrencyRequired',
  visibilitySectionTitle: 'platform.app.activations.listings.details.visibilitySectionTitle',
  visibilitySectionSubtitleShow: 'platform.app.activations.listings.details.visibilitySectionSubitleShow',
  visibilitySectionSubtitleFirstLook: 'platform.app.activations.listings.details.visibilitySectionSubitleFirstLook',
  sectorSectionTitle: 'platform.app.activations.listings.details.sector.title',
  sectorSectionSubtitle: 'platform.app.activations.listings.details.sector.subtitle',
});
